// ▶ Como a ficha do produto CHAMA o preço da caixa/fardo/kg, editando.
//
// Decisão dela após o 1º teste real, 03/09/2026: em vez do rótulo genérico
// "Preço (R$)" (que não dizia se era caixa, fardo ou kg), usar a UNIDADE que
// já está cadastrada no produto -- ele já entende, e o rótulo bate com o que
// ele mesmo digitou em "Unidade".
export function rotuloPrecoCaixa(unidade: string): string {
  const nome = unidade.trim()
  return nome === '' ? 'Preço CX/FD/KG' : `Preço ${nome.toUpperCase()}`
}

// Fixo, e não dinâmico como o da caixa: a unidade avulsa é sempre "unidade
// solta fora da embalagem", nunca muda de nome por produto. Renomeado de
// "Preço UN" para "Valor unitário" -- pedido dela no 2º teste real, 03/09.
export const ROTULO_PRECO_AVULSO = 'Valor unitário'
